import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: { flexDirection: 'row', width: '97%' }, //for later
  label: { fontWeight: '600', fontSize: 15 },
  input: {
    borderColor: 'gray',
    borderRadius: 5,
    margin: 0,
    borderWidth: 0.5,
    height: 50,
    paddingStart: 10,
    flex: 1,
  },
  error: {
    color: 'red',
  },
  anchorRightButton: { position: 'absolute', right: 20, top: 15 },
});
